import { useRouteError } from 'react-router';

export function BubbleErrors() {
  const error = useRouteError();
  throw error;
  return <></>;
}
